import { SEX, CARD_TYPE, CARD_VAL } from './enum'
import { hideInsurantName, judgePhone, judgeCard } from '../../utils'

// 自然人
export const zrrData = [
  {
    title: '申请人信息',
    schema: [
      {
        label: '姓名',
        rules: [
          { required: true, message: '自然人名称不能为空' },
          {
            pattern: new RegExp('^[\u4e00-\u9fa5]{2,16}$'),
            message: '请填写正确的姓名',
          },
        ],
        type: 'input',
        filed: 'applicantName',
        showFiled: 'show_applicantName',
        format: (value: any) => hideInsurantName(value),
      },
      {
        label: '性别',
        rules: [{ required: true, message: '自然人性别不能为空' }],
        type: 'select',
        filed: 'applicantSex',
        props: {
          options: SEX,
        },
      },
      {
        label: '证件类型',
        rules: [{ required: true, message: '自然人证件类型不能为空' }],
        type: 'select',
        filed: 'cardType',
        cardType: CARD_TYPE.PER,
        props: {
          options: [],
        },
      },
      {
        label: '证件号码',
        rules: (data: Record<string, any>) => {
          const { cardType } = data
          const rules: any[] = [{ required: true, message: '自然人证件号码不能为空' }]
          if (CARD_VAL.includes(cardType))
            rules.push({
              pattern: new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/),
              message: '证件号填写错误',
            })
          return rules
        },
        type: 'input',
        filed: 'applicantIdCard',
        showFiled: 'show_applicantIdCard',
        format: (value: any) => judgeCard(value),
      },
      {
        label: '联系电话',
        rules: [
          { required: true, message: '自然人电话不能为空' },
          {
            pattern: new RegExp(/(^1\d{10}$|^(0\d{2,3}-?|0\d2,3)?[1-9]\d{4,7}(-\d{1,8})?$)/),
            message: '请填写正确的电话号码',
          },
        ],
        type: 'input',
        filed: 'applicantPhone',
        showFiled: 'show_applicantPhone',
        format: (value: any) => judgePhone(value),
      },
      {
        label: '电子邮箱',
        type: 'input',
        filed: 'applicantEmail',
        rules: [
          {
            pattern: new RegExp(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/),
            message: '邮箱格式错误',
          },
        ],
      },
      {
        label: '通讯地址',
        type: 'input',
        filed: 'applicantAddress',
      },
    ],
  },
  {
    title: '经办人信息',
    schema: [
      {
        label: '姓名',
        rules: [
          { required: true, message: '联系人姓名不能为空' },
          {
            pattern: new RegExp('^[\u4e00-\u9fa5]{2,16}$'),
            message: '请填写正确的姓名',
          },
        ],
        type: 'input',
        filed: 'contactName',
        showFiled: 'show_contactName',
        format: (value: any) => hideInsurantName(value),
      },
      {
        label: '性别',
        rules: [{ required: true, message: '联系人性别不能为空' }],
        type: 'select',
        filed: 'contactSex',
        props: {
          options: SEX,
        },
      },
      {
        label: '证件类型',
        rules: [{ required: true, message: '联系人证件类型不能为空' }],
        type: 'select',
        filed: 'contactCardType',
        cardType: CARD_TYPE.PER,
        props: {
          options: [],
        },
      },
      {
        label: '证件号码',
        rules: (data: Record<string, any>) => {
          const { contactCardType } = data
          const rules: any[] = [{ required: true, message: '联系人证件号码不能为空' }]
          if (CARD_VAL.includes(contactCardType))
            rules.push({
              pattern: new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/),
              message: '证件号填写错误',
            })
          return rules
        },
        type: 'input',
        filed: 'contactIdCard',
        showFiled: 'show_contactIdCard',
        format: (value: any) => judgeCard(value),
      },
      {
        label: '联系电话',
        rules: [
          { required: true, message: '联系人电话不能为空' },
          {
            pattern: new RegExp(/(^1\d{10}$|^(0\d{2,3}-?|0\d2,3)?[1-9]\d{4,7}(-\d{1,8})?$)/),
            message: '请填写正确的电话号码',
          },
        ],
        type: 'input',
        filed: 'contactPhone',
        showFiled: 'show_contactPhone',
        format: (value: any) => judgePhone(value),
      },
    ],
  },
]
// 法人机构
export const farData = [
  {
    title: '机构信息',
    schema: [
      {
        label: '机构名称',
        rules: [{ required: true, message: '机构名称不能为空' }],
        type: 'input',
        filed: 'orgName',
      },
      {
        label: '机构地址',
        rules: [{ required: true, message: '机构地址不能为空' }],
        type: 'input',
        filed: 'orgAddress',
      },
      {
        label: '组织机构证件类型',
        rules: [{ required: true, message: '组织机构证件类型不能为空' }],
        type: 'select',
        filed: 'orgCardType',
        cardType: CARD_TYPE.ORG,
        props: {
          options: [],
        },
      },
      {
        label: '组织机构代码',
        rules: [{ required: true, message: '组织机构代码不能为空' }],
        type: 'input',
        filed: 'orgIdCard',
      },
      {
        label: '法人姓名',
        rules: [
          { required: true, message: '法人姓名不能为空' },
          {
            pattern: new RegExp('^[\u4e00-\u9fa5]{2,16}$'),
            message: '请填写正确的姓名',
          },
        ],
        type: 'input',
        filed: 'legalPerson',
        showFiled: 'show_legalPerson',
        format: (value: any) => hideInsurantName(value),
      },

      {
        label: '法人证件类型',
        rules: [{ required: true, message: '法人证件类型不能为空' }],
        type: 'select',
        filed: 'legalPersonCardType',
        cardType: CARD_TYPE.PER,
        props: {
          options: [],
        },
      },
      {
        label: '法人证件号',
        rules: (data: Record<string, any>) => {
          const { legalPersonCardType } = data
          const rules: any[] = [{ required: true, message: '法人证件号不能为空' }]
          if (CARD_VAL.includes(legalPersonCardType))
            rules.push({
              pattern: new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/),
              message: '证件号填写错误',
            })
          return rules
        },
        type: 'input',
        filed: 'legalPersonIdCard',
        showFiled: 'show_legalPersonIdCard',
        format: (value: any) => judgeCard(value),
      },
    ],
  },
  {
    title: '申请人信息',
    schema: [
      {
        label: '姓名',
        rules: [
          { required: true, message: '申请人姓名不能为空' },
          {
            pattern: new RegExp('^[\u4e00-\u9fa5]{2,16}$'),
            message: '请填写正确的姓名',
          },
        ],
        type: 'input',
        filed: 'applicantName',
        showFiled: 'show_applicantName',
        format: (value: any) => hideInsurantName(value),
      },
      {
        label: '证件类型',
        rules: [{ required: true, message: '申请人证件类型不能为空' }],
        type: 'select',
        filed: 'cardType',
        cardType: CARD_TYPE.PER,
        props: {
          options: [],
        },
      },
      {
        label: '证件号码',
        rules: (data: Record<string, any>) => {
          const { cardType } = data
          const rules: any[] = [{ required: true, message: '证件号码不能为空' }]
          if (CARD_VAL.includes(cardType))
            rules.push({
              pattern: new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/),
              message: '证件号填写错误',
            })
          return rules
        },
        type: 'input',
        filed: 'applicantIdCard',
        showFiled: 'show_applicantIdCard',
        format: (value: any) => judgeCard(value),
      },
      {
        label: '通讯地址',
        rules: [{ required: true, message: '申请人通讯地址不能为空' }],
        type: 'input',
        filed: 'applicantAddress',
      },
      {
        label: '联系电话',
        rules: [
          { required: true, message: '申请人联系电话不能为空' },
          {
            pattern: new RegExp(/(^1\d{10}$|^(0\d{2,3}-?|0\d2,3)?[1-9]\d{4,7}(-\d{1,8})?$)/),
            message: '请填写正确的电话号码',
          },
        ],
        type: 'input',
        filed: 'applicantPhone',
        showFiled: 'show_applicantPhone',
        format: (value: any) => judgePhone(value),
      },
      {
        label: '邮政编码',
        type: 'input',
        filed: 'applicantPostalCode',
      },
      {
        label: '电子邮箱',
        type: 'input',
        filed: 'applicantEmail',
        rules: [
          {
            pattern: new RegExp(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/),
            message: '邮箱格式错误',
          },
        ],
      },
      {
        label: '备注',
        type: 'input',
        filed: 'remark',
      },
    ],
  },
  {
    title: '经办人信息',
    schema: [
      {
        label: '姓名',
        rules: [
          { required: true, message: '经办人姓名不能为空' },
          {
            pattern: new RegExp('^[\u4e00-\u9fa5]{2,16}$'),
            message: '请填写正确的姓名',
          },
        ],
        type: 'input',
        filed: 'contactName',
        showFiled: 'show_contactName',
        format: (value: any) => hideInsurantName(value),
      },
      {
        label: '性别',
        rules: [{ required: true, message: '经办人性别不能为空' }],
        type: 'select',
        filed: 'contactSex',
        props: {
          options: SEX,
        },
      },
      {
        label: '证件类型',
        rules: [{ required: true, message: '经办人证件类型不能为空' }],
        type: 'select',
        filed: 'contactCardType',
        cardType: CARD_TYPE.PER,
        props: {
          options: [],
        },
      },
      {
        label: '证件号码',
        rules: (data: Record<string, any>) => {
          const { contactCardType } = data
          const rules: any[] = [{ required: true, message: '经办人证件号码不能为空' }]
          if (CARD_VAL.includes(contactCardType))
            rules.push({
              pattern: new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/),
              message: '证件号填写错误',
            })
          return rules
        },
        type: 'input',
        filed: 'contactIdCard',
        showFiled: 'show_contactIdCard',
        format: (value: any) => judgeCard(value),
      },
      {
        label: '联系电话',
        rules: [
          { required: true, message: '经办人联系电话不能为空' },
          {
            pattern: new RegExp(/(^1\d{10}$|^(0\d{2,3}-?|0\d2,3)?[1-9]\d{4,7}(-\d{1,8})?$)/),
            message: '请填写正确的电话号码',
          },
        ],
        type: 'input',
        filed: 'contactPhone',
        showFiled: 'show_contactPhone',
        format: (value: any) => judgePhone(value),
      },
    ],
  },
]
